import React from "react";

const AboutUs: React.FC = () => (
  <>
    <div className="inner-hero">
      <div className="container-fluid ">
        <div className="row">
          <div className="col-md-12 text-center">
            <h1 className="display-4">About Us</h1>
            <p className="lead">
              Learn more about our mission, vision, and the team behind our
              success.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div className="about-section content-section">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="about-images">
              <div className="image1 image-anime reveal">
                <img src="/Images/about-page-sec1-image1.png" alt="" />
              </div>
              <div className="image2 image-anime reveal">
                <img src="/Images/about-page-sec1-image2.png" alt="" />
              </div>
            </div>
          </div>
          <div className="col-lg-6 d-flex flex-column gap-4">
            <div>
              <span className="text-muted text-highlight">Our Journey</span>
            </div>
            <h2 className="tx-36 _500 ">About Us</h2>
            <p className="lead tx-16 1h-base">
              Established in 1994, IOS RELOCATIONS has emerged as a pioneer in
              corporate relocations, providing tailored solutions to businesses
              and individuals worldwide. Over the past three decades, we started
              our journey in India 30 years ago, to become a prominent player in
              the global relocation industry. With 12 years of experience in
              Dubai, UAE, and a 5 year footprint in Saudi Arabia, offering
              end-to-end relocation services, we've solidified our reputation
              for professionalism and excellence.
            </p>
            <p className="lead tx-16 1h-base">
              <span className="_600">Our Vision : </span>
              <h5 className="tx-18 _600">Different in The Way We Care.</h5>
              We envision transcending boundaries and shaping the future of
              relocation as the unparalleled global leader. Our vision is not
              merely about reaching new heights but about pioneering uncharted
              territories while remaining grounded in our commitment to
              unparalleled service. As we move forward, we embrace innovation
              and growth, always staying ahead of the curve. Yet, amidst our
              pursuit of progress, we hold steadfast to the belief that
              personalized care is the cornerstone of our success. Our journey
              is not just about moving further; it's about moving further with
              purpose, integrity, and an unwavering dedication to exceeding the
              expectations of those we serve.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div className="team-section content-section bg-dark">
      <div className="container">
        <div className="row ">
          <div className="col-md-12 d-flex gap-4 flex-column text-center">
            <div>
              <span className="text-muted text-highlight">Our Leaders</span>
            </div>
            <h2 className="tx-36 _500 text-white">
              The Minds Behind Our Success
            </h2>
          </div>
          <div className="col-md-6">
            <div className="box">
              <div className="top-bar"></div>
              <div className="team-content">
                <div className="image-anime reveal d-flex flex-column align-items-center">
                  <img src="/Images/Lata.png" alt="Lata Patel" />
                  <h4 className="tx-22 _600">Lata Patel</h4>
                  <p className="tx-18 _600">Founder</p>
                </div>

                <p className="fst-italic _500 mb-2">
                  “Quality service is the best business plan. Period.”
                </p>
                <p className="mb-1">
                  A visionary leader in the relocation industry.
                </p>
                <p className="mb-1">
                  With a foundation in international tax expertise from her
                  tenure at KPMG in Chicago, USA, Lata embarked on a journey
                  that led her to establish IOS RELOCATIONS in 1994.
                </p>
                <p className="mb-1">
                  Drawing from her own expat experience, she meticulously shaped
                  IOS RELOCATIONS into a leader in corporate relocation services
                  across India, South East Asia, and the Middle East.
                </p>
                <p className="mb-1">
                  Under her guidance, IOS RELOCATIONS has evolved from its
                  origins in immigration and relocations to offering a
                  comprehensive suite of services, driven by her commitment to
                  personalized care.
                </p>
                <p className="mb-1">
                  Certified in Global Mobility and recognized for her expertise,
                  Lata's vision is to make IOS RELOCATIONS an international
                  powerhouse, providing seamless relocations worldwide.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="box">
              <div className="top-bar"></div>
              <div className="team-content">
                <div className="image-anime reveal d-flex flex-column align-items-center">
                  <img src="/Images/rajesh.png" alt="Rajesh" />
                  <h4 className="tx-22 _600">Rajesh Motwani</h4>
                  <p className="tx-18 _600">CEO</p>
                </div>
                <p className="fst-italic _500 mb-2">
                  "Success lies in foreseeing the demands and strategising to
                  optimise it.”
                </p>
                <p className="mb-1">
                  Rajesh Motwani, an accomplished leader with a strong IT
                  background, has been the CEO of IOS RELOCATIONS since 2017.
                  Leveraging his expertise in technology and cloud computing,
                  Rajesh has transformed operations to achieve efficiency and
                  excellence. His strategic direction and commitment to building
                  a process-oriented organization have positioned IOS for
                  significant growth.
                </p>
                <p className="mb-1">
                  With over 25 years of experience in global roles at SAP,
                  Oracle, and BusinessObjects, Rajesh has excelled in business
                  development, account management, and marketing. He has forged
                  successful partnerships with industry leaders like Deloitte,
                  IBM, and Accenture. Rajesh holds a Master’s in Computer
                  Science from George Mason University and a Bachelor’s in
                  Engineering from Mumbai University.
                </p>
                <p className="mb-1">
                  Beyond his professional achievements, Rajesh actively promotes
                  art through a children's program in Bangalore, fostering
                  creativity and inclusivity.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </>
);

export default AboutUs;
